import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import Pseudo from 'i18next-pseudo';

// not like to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init
let isPseudo = !localStorage.getItem('netacad-pseudo-localize')
  ? false
  : localStorage.getItem('netacad-pseudo-localize') === 'false'
  ? false
  : true;
i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .use(
    new Pseudo({
      enabled: isPseudo,
      languageToPseudo: localStorage.getItem('i18nextLng'),
      letterMultiplier: 4,
      repeatedLetters: ['B', 'o', 'a', 't']
    })
  )
  .init({
    fallbackLng: 'en-US',
    // ns: [],
    // defaultNS: '',

    // for devving only
    // debug: true,

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      addPath: '/locales/{{lng}}/{{ns}}.json'
    },

    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    postProcess: isPseudo ? ['pseudo'] : []
  })
  .then(() => {
    // get the language direction
    const langDirection = i18n.dir();
    const htmlElement = document.getElementsByTagName('html')[0];

    // set the direction on the root <html> element
    htmlElement.setAttribute('dir', langDirection);

    // set the lang attribute on the root <html> element
    htmlElement.setAttribute('lang', i18n.language);
  });

export default i18n;
